import { UseQueryOptions, useQuery } from "@tanstack/react-query";
import { FirestoreError } from "firebase/firestore";
import useUserStore from "@/modules/users/store";
import { getSumMoedasPerIdeia } from "../firestore";

type TGetSumMoedasPerIdeiaResponse = Awaited<ReturnType<typeof getSumMoedasPerIdeia>>;
type TQueryOptions = Omit<UseQueryOptions<TGetSumMoedasPerIdeiaResponse, FirestoreError, number>, "queryKey">;

/**
 * Get ideia activities per colaborador
 * @param ideia - Ideia to get activities
 * @param options - Query options to use
 * @returns - Query result
 */
function useGetTotalMoedasPerIdeia(ideia: TIdeia | null, options: TQueryOptions = {}) {
  const activeEmpresaId = useUserStore((state) => state.activeEmpresaId);
  return useQuery<TGetSumMoedasPerIdeiaResponse, FirestoreError, number | null>({
    queryKey: [activeEmpresaId, "ideia", ideia?.id, "activities", "moedas", ideia, ideia?.id],
    queryFn() {
      if (!activeEmpresaId) {
        throw new Error("Empresa não selecionada");
      }
      if (!ideia) {
        throw new Error("Ideia não informada");
      }

      return getSumMoedasPerIdeia(activeEmpresaId, ideia.id);
    },
    select(dataSnapshot) {
      return dataSnapshot.data().moedas;
    },
    enabled: !!ideia,
    ...options
  });
}

export default useGetTotalMoedasPerIdeia;
